
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggwcURqQdK_47YI2xEWtdOjwE9x8XGlmw31sDLiNVbYkMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexVGqV4hbAsfdq3UTylLeMX1R1wA3Q0irwCtUQOS2M_45QsMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchDH_sFGGujga51_CKLiNpbm3TSvOHwj14B4rg5c2N2pMMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index5kWer2uYIGj7KnpKklGaPg5m6MC6VI__S11iO2SU4XsMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93eWM8QNIwvbRSMBOXqu60yh_v1k_gD5EgZAFCuF5IFP8Meta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexCRc2YPI7TENsmRYmrPzBn8eJvE_456_452s5a66lW606yO0Meta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_930LLZ9lGnmWtkLq5N6e3KyhnKpsNTF4zZZnheauKl6vsMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexPDDg2oGb0Lm7RkTQOSnFGRkv_45K3AWgMUI02aQvt_7osMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93bkvyQF1BIzZY5voXLxzrOAfuw2hAkYHlfsjEWEVzhmIMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexb_d9D7wJoA_45IJE_dETZ4Rzj3wEqsTpBS9_45loAGn7uG4Meta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexCHuojjtlXOvGfFMkS3WsjVJgDYJHgw04sMUjArLb3gAMeta } from "/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexCRc2YPI7TENsmRYmrPzBn8eJvE_456_452s5a66lW606yO0Meta || {},
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexPDDg2oGb0Lm7RkTQOSnFGRkv_45K3AWgMUI02aQvt_7osMeta || {},
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexb_d9D7wJoA_45IJE_dETZ4Rzj3wEqsTpBS9_45loAGn7uG4Meta || {},
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexCHuojjtlXOvGfFMkS3WsjVJgDYJHgw04sMUjArLb3gAMeta || {},
    component: () => import("/codebuild/output/src145924509/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]